<template>
  <v-content>
    <v-container grid-list-md fluid>
      <v-layout row wrap>
        <v-flex xs12>
          <BetaNote></BetaNote>
        </v-flex>

        <v-flex xs6 sm4>
          <!--<PatientSelect></PatientSelect>-->
        </v-flex>
        <v-flex xs4 offset-xs2 offset-sm4>
          <VersionSelect
            :selected-version="selectedVersion"
            v-on:change-version="handleChangeVersion"
          ></VersionSelect>
        </v-flex>

        <v-flex xs12>
          <v-card class="elevation-1" id="data-table">
            <v-card-actions>
              <CreateUpdatePositionDialog
                v-model="cuPositionDialog"
                :edited-position="editedPosition"
                :edited-index="editedIndex"
                v-on:create-or-update="handleCreateOrUpdatePosition"
                :tarmed-version="selectedVersion"
              >
              </CreateUpdatePositionDialog>

              <PositionTableToolbar
                :validateable="validateable"
                :loading="validationIsLoading"
                v-on:new-position="handleNewPosition"
                v-on:validate="validate"
                v-on:sort="sortPositions"
              >
              </PositionTableToolbar>
            </v-card-actions>

            <v-expand-transition>
              <v-toolbar
                :class="validationColorClass"
                dark
                prominent
                flat
                v-show="reportBanner"
                id="reportBanner"
              >
                <v-btn icon @click="reportBanner = false">
                  <v-icon>close</v-icon>
                </v-btn>
                <template v-if="reportIsValid && !reportHasWarnings">
                  <v-toolbar-title>
                    <!--<v-icon>check_circle</v-icon>-->
                    Validierung: Erfolgreich
                  </v-toolbar-title>
                </template>
                <template v-else-if="reportIsValid && reportHasWarnings">
                  <v-toolbar-title>
                    <!--<v-icon>warning</v-icon>-->
                    Validierung: Warnungen festgestellt
                  </v-toolbar-title>
                </template>
                <template v-else-if="reportIsInvalid">
                  <v-toolbar-title>
                    <!--<v-icon>error</v-icon>-->
                    Validierung: Fehler festgestellt
                  </v-toolbar-title>
                </template>
                <v-spacer></v-spacer>
                <v-tooltip top>
                  <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                      icon
                      v-on="{ ...tooltip }"
                      @click="$vuetify.goTo('#report')"
                    >
                      <v-icon>assignment</v-icon>
                    </v-btn>
                  </template>
                  <span>Bericht</span>
                </v-tooltip>
              </v-toolbar>
            </v-expand-transition>

            <PositionTable
              :positions="positions"
              :loading="validationIsLoading"
              v-on:edit-position="handleEditPosition"
              v-on:delete-position="handleDeletePosition"
            ></PositionTable>

            <v-card-text v-if="validated" id="report">
              <h2>Validierung: Bericht</h2>

              <template v-if="reportIsValid && !reportHasWarnings">
                <v-alert
                  class="report-alert elevation-2"
                  :value="true"
                  type="success"
                  outline
                >
                  <p>Es konnten keine Fehler festgestellt werden.</p>
                  <v-divider class="mb-3"></v-divider>
                  <p class="mb-0">
                    Die Ergebnisse der Validierung stellen keine Empfehlung zur Abrechnung dar. Bitte lesen Sie die
                    <a href="/de/hinweise" target="_new">Hinweise zur Validierung</a> aufmerksam durch.
                  </p>
                  <div class="report-alert-border"></div>
                </v-alert>
              </template>

              <template v-else-if="reportIsValid && reportHasWarnings">
                <v-alert
                  class="report-alert elevation-2"
                  :value="true"
                  type="warning"
                  outline
                >
                  <p>Die Validierung hat Warnungen festgestellt. Diese können zu fehlerhafter Validierung oder einer ungültigen Rechnung führen. Bitte korrigieren Sie die Warnungen und versuchen Sie es erneut. Die Details finden Sie bei den einzelnen Positionen.</p>
                  <template v-if="commonWarnings.length > 0">
                    <h3>Generelle Warnungen:</h3>
                    <ul class="mb-3">
                      <li :key="index" v-for="(warning, index) in commonWarnings">
                        {{ warning.message }}
                      </li>
                    </ul>
                  </template>
                  <v-divider class="mb-3"></v-divider>
                  <p class="mb-0">
                    Die Ergebnisse der Validierung stellen keine Empfehlung zur Abrechnung dar. Bitte lesen Sie die
                    <a href="/de/hinweise" target="_new">Hinweise zur Validierung</a> aufmerksam durch.
                  </p>
                  <div class="report-alert-border"></div>
                </v-alert>
              </template>

              <template v-else-if="reportIsInvalid">
                <v-alert
                  class="report-alert elevation-2"
                  :value="true"
                  type="error"
                  outline
                >
                  <p>Die Validierung hat Fehler festgestellt. Bitte korrigieren Sie die Fehler und versuchen Sie es erneut. Die Details finden Sie bei den einzelnen Positionen.</p>
                  <template v-if="commonErrors.length > 0">
                    <h3>Generelle Fehler:</h3>
                    <ul class="mb-3">
                      <li :key="index" v-for="(error, index) in commonErrors">
                        {{ error.message }}
                      </li>
                    </ul>
                  </template>
                  <v-divider class="mb-3"></v-divider>
                  <p class="mb-0">
                    Die Ergebnisse der Validierung stellen keine Empfehlung zur Abrechnung dar. Bitte lesen Sie die
                    <a href="/de/hinweise" target="_new">Hinweise zur Validierung</a> aufmerksam durch.
                  </p>
                  <div class="report-alert-border"></div>
                </v-alert>
              </template>

              <!--<code>{{ validationReport }}</code>-->
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>

import BetaNote from "./BetaNote"
import CreateUpdatePositionDialog from "./CreateUpdatePositionDialog"
import PositionTable from "./PositionTable"
import PatientSelect from "./PatientSelect"
import PositionTableToolbar from "./PositionTableToolbar"
import QualificationSelect from "./QualificationSelect"
import Tracking from "./Tracking.js"
import VersionSelect from "./VersionSelect"

export default {
  components: {
    BetaNote,
    CreateUpdatePositionDialog,
    PatientSelect,
    PositionTable,
    PositionTableToolbar,
    QualificationSelect,
    VersionSelect
  },
  data() {
    return {
      cuPositionDialog: false,  // create-update dialog shown
      positions: [],
      editedIndex: -1,
      defaultPosition: {
        date: new Date().toISOString().substr(0, 10),
        code: "",
        title: "",
        ref_code: null,
        session: 1,
        quantity: 1,
        errors: [],
        warnings: []
      },
      editedPosition: {
        date: new Date().toISOString().substr(0, 10),
        code: "",
        title: "",
        ref_code: null,
        session: 1,
        quantity: 1,
        errors: [],
        warnings: []
      },
      selectedVersion: "01.09",
      validated: false,
      reportBanner: false,
      validationIsLoading: false,
      validationReport: {}
    }
  },

  computed: {
    // Returns true, when the positions can be validated
    validateable() {
      return this.positions.length > 0
    },

    /**
     * Computes a color string, depending on the validationReport object
     */
    validationColorClass() {
      if (this.validationReport.validation == "valid" && this.validationReport.warnings.length == 0) {
        return "success"
      } else if (this.validationReport.validation == "valid" && this.validationReport.warnings.length > 0) {
        return "warning"
      } else if (this.validationReport.validation == "invalid") {
        return "error"
      }

      return ""
    },

    /**
     * Computes a unique string, depending on the validationReport status
     */
    validationStatus() {
      if (this.validationReport.validation == "valid" && this.validationReport.warnings.length == 0) {
        return "valid"
      } else if (this.validationReport.validation == "valid" && this.validationReport.warnings.length > 0) {
        return "valid-with-warnings"
      } else if (this.validationReport.validation == "invalid") {
        return "invalid"
      }

      return ""
    },

    /**
     * Returns, if the report is valid
     */
    reportIsValid() {
      return this.validationReport.validation == 'valid'
    },

    /**
     * Returns, if the report is invalid
     */
    reportIsInvalid() {
      return this.validationReport.validation == 'invalid'
    },

    /**
     * Returns, if the report has errors
     */
    reportHasErrors() {
      return this.validationReport.errors.length > 0
    },

    /**
     * Returns, if the report has warnings
     */
    reportHasWarnings() {
      return this.validationReport.warnings.length > 0
    },

    /**
     * Returns the common errors of the validation report,
     * which can not assigned to a specific position
     */
    commonErrors() {
      let errors = []
      for (let i = 0; i < this.validationReport.errors.length; i++) {
        if (!this.validationReport.errors[i].index) errors.push(this.validationReport.errors[i])
      }
      return errors
    },

    /**
     * Returns the common warnings of the validation report,
     * which can not assigned to a specific position
     */
    commonWarnings() {
      let warnings = []
      for (let i = 0; i < this.validationReport.warnings.length; i++) {
        if (!this.validationReport.warnings[i].index) warnings.push(this.validationReport.warnings[i])
      }
      return warnings
    }
  },

  methods: {
    /**
     * Main component methods
     */
    validate() {
      this.validationIsLoading = true
      let payload = {
        config: {
          ignore_errors: [
            6100    // ignore qualification check as long as qualification can't be set
          ]
        },
        //patient: { dob: "lasdfjkaklsdfje" }, // for generating common error
        services: [],
        locale: "de",
        tarmed_version: this.selectedVersion
      }

      for (let i = 0; i < this.positions.length; i++) {
        payload.services.push({
          code: this.positions[i].code,
          ref_code: this.positions[i].ref_code,
          date: this.positions[i].date,
          session: this.positions[i].session,
          quantity: this.positions[i].quantity
        })
      }

      this.$http.put("/validate", payload)
        .then(response => {
          this.validationReport = response.data
        })
        .catch(error => {
          // TODO: implement user feedback
          console.error(error)
          Tracking.pageview("/de/validator/validate/error", { dimension1: this.selectedVersion });
          setTimeout(() => (this.validationIsLoading = false), 300)
        })
        .finally(() => {
          this.resetPositionErrorsAndWarnings()
          this.validated = true
          this.reportBanner = true
          Tracking.pageview("/de/validator/validate", { dimension1: this.selectedVersion, dimension2: this.validationStatus });
          setTimeout(() => (this.validationIsLoading = false), 300)
        })

    },

    /**
     * Sort positions
     */
    sortPositions() {
      this.positions.sort((a, b) => {
        return (
          (a.date > b.date ? 1 : (b.date > a.date ? -1 : 0))
          || (a.session > b.session ? 1 : (b.session > a.session ? -1 : 0))
          || a.code.localeCompare(b.code)
        )
      });
    },

    /**
     * Resets and assigns the errors and warnings to the positions.
     */
    resetPositionErrorsAndWarnings() {
      for (let i = 0; i < this.positions.length; i++) {
        this.positions[i].errors = []
        this.positions[i].warnings = []
      }

      // assign errors to positions
      // TODO: check if first error is correctly assigned
      for (let i = 0; i < this.validationReport.errors.length; i++) {
        if (this.validationReport.errors[i].index >= 0) {
          this.positions[this.validationReport.errors[i].index].errors.push(this.validationReport.errors[i])
        }
      }

      // assign warnings to positions
      for (let i = 0; i < this.validationReport.warnings.length; i++) {
        if (this.validationReport.warnings[i].index >= 0) {
          this.positions[this.validationReport.warnings[i].index].warnings.push(this.validationReport.warnings[i])
        }
      }
    },

    /**
     * Handlers from other components, emitted events
     */
    // VersionSelect
    handleChangeVersion(version) {
      this.selectedVersion = version
      Tracking.pageview("/de/validator/version/change")
    },

    // CreateUpdatePositionDialog
    handleCreateOrUpdatePosition(position) {
      // set position to null, if none was given
      if (position.ref_code == "") position.ref_code = null;

      if (this.editedIndex > -1) {
        Object.assign(this.positions[this.editedIndex], position)
        Tracking.pageview("/de/validator/positions/update")
      } else {
        this.positions.push(position)
        this.calculatePositionsIndex()
        Tracking.pageview("/de/validator/positions/create")
      }
    },

    // PositionTable
    handleEditPosition(position) {
      this.editedIndex = this.positions.indexOf(position)
      this.editedPosition = Object.assign({}, position)
      this.cuPositionDialog = true
      Tracking.pageview("/de/validator/positions/edit")
    },

    // PositionTable
    handleDeletePosition(position) {
      const index = this.positions.indexOf(position)
      this.positions.splice(index, 1)
      this.calculatePositionsIndex()
      Tracking.pageview("/de/validator/positions/delete")
    },

    // PositionTableToolbar
    handleNewPosition() {
      this.editedIndex = -1
      this.editedPosition = Object.assign({}, this.defaultPosition)
      this.cuPositionDialog = true
      Tracking.pageview("/de/validator/positions/new")
    },

    /**
     * Re-calculates index for the positions array
     *
     * index is needed for a unique identifier, e.g. when expanding a row.
     */
    calculatePositionsIndex() {
      for (let i = 0; i < this.positions.length; i++) {
        this.positions[i].index = i
      }
    }
  },

  created() {
    this.positions = [
      // ex1
      /*
      { index: 0, date: "2019-03-30", code: "00.0010", session: 1, quantity: 1, title: "Konsultation, erste 5 Min. (Grundkonsultation)", errors: [], warnings: [] },
      { index: 1, date: "2019-03-30", code: "00.0020", ref_code: "00.0010", session: 1, quantity: 1, title: "+ Konsultation bei Personen über 6 Jahren und unter 75 Jahren, jede weiteren 5 Min. (Konsultationszuschlag)", errors: [], warnings: [] },
      { index: 2, date: "2019-03-30", code: "00.0020", ref_code: "00.0010", session: 1, quantity: 1, title: "+ Konsultation bei Personen über 6 Jahren und unter 75 Jahren, jede weiteren 5 Min. (Konsultationszuschlag)", errors: [], warnings: [] },
      { index: 3, date: "2019-03-30", code: "00.0025", session: 1, quantity: 1, title: "+ Konsultation bei Kindern unter 6 Jahren und Personen über 75 Jahren, jede weiteren 5 Min.", errors: [], warnings: [] }
      */
      // ex2
      /*
      { index: 0, date: "2019-05-20", code: "02.0020", session: 1, quantity: 15, title: "Psychiatrische Diagnostik und Therapie, Einzeltherapie, jede weitere Sitzung, pro 5 Min.", errors: [], warnings: [] },
      { index: 1, date: "2019-05-20", code: "02.0073", session: 1, quantity: 14, title: "Auskünfte an Angehörige oder andere Bezugspersonen des Patienten in Abwesenheit des Patienten durch den Facharzt für Psychiatrie, pro 1 Min.", errors: [], warnings: [] },
      { index: 2, date: "2019-06-03", code: "02.0020", session: 2, quantity: 14, title: "Psychiatrische Diagnostik und Therapie, Einzeltherapie, jede weitere Sitzung, pro 5 Min.", errors: [], warnings: [] },
      { index: 3, date: "2019-06-17", code: "02.0020", session: 3, quantity: 14, title: "Psychiatrische Diagnostik und Therapie, Einzeltherapie, jede weitere Sitzung, pro 5 Min.", errors: [], warnings: [] },
      */
    ]
  }
}
</script>

<style scoped>
#reportBanner {
  z-index: 1;
}
.report-alert-border {
  left: 0;
  top: 0;
  bottom: 0;
  border-style: solid;
  border-width: 4px;
  content: "";
  position: absolute;
  opacity: 0.25;
}
div.report-alert {
  border: none !important;
}
div.report-alert >>> div p, div.report-alert >>> div ul, div.report-alert >>> div h3 {
  color: rgba(0,0,0,0.87);
}
div.report-alert.v-alert >>> .v-alert__icon.v-icon {
  align-self: start !important;
}
</style>
